import { React, useState  } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { InterventionTypeForm } from '../InterventionTypeForm/InterventionTypeForm';
import * as api from 'services/api';
import { useTranslation } from 'react-i18next';
export function NewInterventionType() {
    const { t } = useTranslation();
    const [interventionTypeFormData, setInterventionTypeFormData] = useState({
        name: '',
        text: '',
        integrationId: 0,
        updatePhone:false,
        enable: true,
        mobileDevice: false,
        checkLocation: false,
        selectedPhone: 1,
        deletePhone: false,
        controlDigitsNumber: 0
    });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setInterventionTypeFormData({
            ...interventionTypeFormData,
            [name]: value
        });
    };

    const handleSubmit = async () => {
        const payload = {
            ...interventionTypeFormData,
            integrationId: parseInt(interventionTypeFormData.integrationId, 10) // 👈 conversión aquí
        };
        const response = await api.createInterventionType(payload);
        if (response.status === 200) {
            navigate('/interventionTypeManagement');      
        } else {
            setError(t('usError'));
        }
    };
  
    return (
        <Container>
            <h2 className="mt-4">{t('it.New')}</h2>
            <InterventionTypeForm
                interventionTypeFormData={interventionTypeFormData}
                handleInputChange={handleInputChange}
                handleSubmit={handleSubmit}
                error={error}
                setError={setError}
                isEditing={false}
            />
        </Container>
    );
}